import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Heart } from "lucide-react";
import { BRAND } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-plum text-cream mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={BRAND.logo}
              alt="Lorena Cotano"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <div className="font-serif text-2xl">{BRAND.name}</div>
              <div className="font-sans text-[10px] uppercase tracking-[0.2em] text-amber">
                {BRAND.role}
              </div>
            </div>
          </div>
          <p className="font-body text-cream/75 max-w-md leading-relaxed">
            Un espacio de escucha, cuidado y conocimiento para mujeres que
            atraviesan el embarazo, el puerperio y la menopausia. Estoy aquí
            para recorrer este camino contigo.
          </p>
        </div>

        <div>
          <h4 className="font-sans uppercase tracking-[0.15em] text-xs text-amber mb-4">
            Explora
          </h4>
          <ul className="space-y-2.5 font-body text-cream/80">
            <li><Link to="/articulos" className="hover:text-amber transition-colors">Artículos</Link></li>
            <li><Link to="/cursos" className="hover:text-amber transition-colors">Cursos</Link></li>
            <li><Link to="/comunidad" className="hover:text-amber transition-colors">Comunidad</Link></li>
            <li><Link to="/sesiones" className="hover:text-amber transition-colors">Sesiones online</Link></li>
            <li><Link to="/membresia" className="hover:text-amber transition-colors">Membresía</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-sans uppercase tracking-[0.15em] text-xs text-amber mb-4">
            Contacto
          </h4>
          <ul className="space-y-3 font-body text-cream/80">
            <li className="flex items-center gap-2.5">
              <Mail size={17} className="text-amber" /> hola@lorenacotano.com
            </li>
            <li>
              <a
                href="https://instagram.com/lorenacotano"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 hover:text-amber transition-colors"
              >
                <Instagram size={17} className="text-amber" /> @lorenacotano
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-cream/60 font-body text-sm">
          <span>© {new Date().getFullYear()} Lorena Cotano · Todos los derechos reservados</span>
          <span className="flex items-center gap-1.5">
            Hecho con <Heart size={14} className="text-rose fill-rose" /> para acompañarte
          </span>
        </div>
      </div>
    </footer>
  );
}
